import userTypes from './userTypes';
import { decodeTokenPayload } from '../../utils/jwt';

export const INITIAL_STATE = {
  currentUser: null,
  error: false,
  fetching: false,
  fetchingAvatar: false,
  updatingProfile: false,
  isChangePwd: false,
  token: localStorage.getItem('token'),
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userTypes.FORGETPWD_END: {
      return { ...state, isChangePwd: false };
    }
    case userTypes.FORGETPWD_START:{
      return { ...state, isChangePwd: true};
    }
    case userTypes.SIGN_UP_START:
    case userTypes.SIGN_IN_START: {
      return { ...state, error: false, fetching: true };
    }
    case userTypes.SIGN_IN_SUCCESS: {
      const { user, token } = action.payload;
      const payload = decodeTokenPayload(token);
      const roles = Array.isArray(user?.roles) ? user.roles : [];

      const isImpersonating =
        typeof user?.isImpersonating === 'boolean'
          ? user.isImpersonating
          : Boolean(payload?.orig_admin_id);

      const originalAdminId =
        user?.originalAdminId || payload?.orig_admin_id || null;
      const originalAdminUsername =
        user?.originalAdminUsername || payload?.orig_admin_username || null;
      const actingUserId =
        payload?.act_as_user_id ||
        user?.actingUserId ||
        user?.userId ||
        user?._id ||
        null;

      return {
        ...state,
        currentUser: {
          ...user,
          roles,
          isImpersonating,
          originalAdminId,
          originalAdminUsername,
          actingUserId,
        },
        error: false,
        fetching: false,
        token,
      };
    }
    case userTypes.SIGN_UP_FAILURE:
    case userTypes.SIGN_IN_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    }
    case userTypes.SIGN_OUT: {
      return {
        ...state,
        currentUser: null,
        token: null,
      };
    }
    case userTypes.BOOKMARK_POST: {
      const { operation, postId } = action.payload;
      let bookmarks = JSON.parse(JSON.stringify(state.currentUser.bookmarks));
      if (operation === 'add') {
        bookmarks.push({ post: postId });
      } else {
        bookmarks = bookmarks.filter((bookmark) => bookmark.post !== postId);
      }
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          bookmarks,
        },
      };
    }
    case userTypes.REMOVE_AVATAR_START:
    case userTypes.CHANGE_AVATAR_START: {
      return { ...state, fetchingAvatar: true };
    }
    case userTypes.CHANGE_AVATAR_SUCCESS: {
      return {
        ...state,
        currentUser: { ...state.currentUser, avatar: action.payload },
        fetchingAvatar: false,
      };
    }
    case userTypes.REMOVE_AVATAR_FAILURE:
    case userTypes.CHANGE_AVATAR_FAILURE: {
      return {
        ...state,
        fetchingAvatar: false,
        error: action.payload,
      };
    }
    case userTypes.REMOVE_AVATAR_SUCCESS: {
      // Removing the avatar key from the currentUser object
      const { avatar, ...additionalKeys } = state.currentUser;
      return {
        ...state,
        currentUser: { ...additionalKeys },
        fetchingAvatar: false,
        error: false,
      };
    }
    case userTypes.UPDATE_PROFILE_START: {
      return {
        ...state,
        updatingProfile: true,
      };
    }
    case userTypes.UPDATE_PROFILE_SUCCESS: {
      return {
        ...state,
        error: false,
        updatingProfile: false,
        currentUser: { ...state.currentUser, ...action.payload },
      };
    }
    case userTypes.UPDATE_PROFILE_FAILURE: {
      return {
        ...state,
        updatingProfile: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

export default userReducer;
